import axios from 'axios';
import store from '../store';
import qs from 'qs'
const service = axios.create({
  baseURL: '/api',
  timeout: 300000, // 暂时设定5min超时
  Headers: { 'Content-Type': 'application/json' },
  //Headers: {'Content-Type': 'application/x-www-form-urlencoded'}
});

service.interceptors.request.use((config) => {
  config.headers['Authorization'] = '';
  //config.headers['token'] = '01234567890';
  return config;
});
service.interceptors.response.use(
  (data) => {
    if (data.status === 200) {
      return data.data;
    } else {
      return data;
    }
  },
  (error) => {
    if (error.message.includes("timeout")) {
      // 超时处理
    }
  }
);

export default service;
